export const currencyCodes = [
  "AED",
  "AUD",
  "BHD",
  "CAD",
  "EGP",
  "EUR",
  "GBP",
  "JOD",
  "KWD",
  "QAR",
  "SAR",
  "USD",
  "PLN",
  "UAH",
  "ZAR",
];

export const currencyDisplayNames: Record<string, string> = {
  AED: "AED - UAE Dirham",
  AUD: "AUD - Australian Dollar",
  BHD: "BHD - Bahraini Dinar",
  CAD: "CAD - Canadian Dollar",
  EGP: "EGP - Egyptian Pound",
  EUR: "EUR - Euro",
  GBP: "GBP - British Pound",
  JOD: "JOD - Jordanian Dinar",
  KWD: "KWD - Kuwaiti Dinar",
  QAR: "QAR - Qatari Riyal",
  SAR: "SAR - Saudi Riyal",
  USD: "USD - US Dollar",
  PLN: "PLN - Polish Złoty",
  UAH: "UAH - Ukrainian Hryvnia",
  ZAR: "ZAR - South African Rand",
};

export const currencySymbols: Record<string, string> = {
  AED: "AED",
  AUD: "$",
  BHD: "BHD",
  CAD: "$",
  EGP: "£",
  EUR: "€",
  GBP: "£",
  JOD: "JOD",
  KWD: "KWD",
  QAR: "QAR",
  SAR: "SAR",
  USD: "$",
  PLN: "zł",
  UAH: "₴",
  ZAR: "R",
};

export const locales = [
  "ar-AE",
  "ar-BH",
  "ar-EG",
  "ar-JO",
  "ar-KW",
  "ar-QA",
  "ar-SA",
  "ca-ES",
  "de-DE",
  "en-AU",
  "en-CA",
  "en-GB",
  "en-IE",
  "en-PR",
  "en-US",
  "en-ZA",
  "es-419",
  "es-ES",
  "es-PR",
  "fr-CA",
  "fr-FR",
  "it-IT",
  "nl-NL",
  "pl-PL",
  "ru-RU",
  "uk-UA",
  "zh-Hans-CN",
];

export const localeDisplayNames: Record<string, string> = {
  "ar-AE": "ar-AE - Arabic (United Arab Emirates)",
  "ar-BH": "ar-BH - Arabic (Bahrain)",
  "ar-EG": "ar-EG - Arabic (Egypt)",
  "ar-JO": "ar-JO - Arabic (Jordan)",
  "ar-KW": "ar-KW - Arabic (Kuwait)",
  "ar-QA": "ar-QA - Arabic (Qatar)",
  "ar-SA": "ar-SA - Arabic (Saudi Arabia)",
  "ca-ES": "ca-ES - Catalan (Spain)",
  "de-DE": "de-DE - German (Germany)",
  "en-AU": "en-AU - English (Australia)",
  "en-CA": "en-CA - English (Canada)",
  "en-GB": "en-GB - English (United Kingdom)",
  "en-IE": "en-IE - English (Ireland)",
  "en-PR": "en-PR - English (Puerto Rico)",
  "en-US": "en-US - English (United States)",
  "en-ZA": "en-ZA - English (South Africa)",
  "es-419": "es-419 - Spanish (Latin America)",
  "es-ES": "es-ES - Spanish (Spain)",
  "es-PR": "es-PR - Spanish (Puerto Rico)",
  "fr-CA": "fr-CA - French (Canada)",
  "fr-FR": "fr-FR - French (France)",
  "it-IT": "it-IT - Italian (Italy)",
  "nl-NL": "nl-NL - Dutch (Netherlands)",
  "pl-PL": "pl-PL - Polish (Poland)",
  "ru-RU": "ru-RU - Russian (Russia)",
  "uk-UA": "uk-UA - Ukrainian (Ukraine)",
  "zh-Hans-CN": "zh-Hans-CN - Chinese Simplified (China)",
};
